<template>
  <div class="goldSale">
    <c-nav></c-nav>
    <div class="head">
      <div class="light"></div>
      <div class="header">
        <div class="cost"></div>
        <div class="goldBox">
          高铁管家
          <span>黄金会员</span>礼包
        </div>
        <div class="differentTrip"></div>
      </div>
    </div>
    <div class="body">
      <div class="title">购超值出行礼包，送黄金会员专属权益</div>
      <div class="passengerGift" @click="gotoConfirm(0)">
        <div class="left">
          <div class="passengerGiftTitle">优先加速的抢票礼包</div>
          <div class="desc">光速抢票券5张</div>
          <div class="desc">优先出票券5张</div>
          <div class="subDesc">总价值：40x5+20x5=300元，现购立省251元</div>
        </div>
        <div class="right fx fx-center">
          <div class="buyNow">
            <div>49元</div>
            <div>立购</div>
          </div>
        </div>
      </div>
      <div class="speedGift" @click="gotoConfirm(1)">
        <div class="left">
          <div class="speedGiftTitle">单单返现的常旅客礼包</div>
          <div class="desc">火车票首单立返15元</div>
          <div class="desc">1年内每单返现5元</div>
          <div class="subDesc">限本人购票，全年最高返现：15+5x8=55元</div>
        </div>
        <div class="right fx fx-center">
          <div class="buyNow">
            <div>49元</div>
            <div>立购</div>
          </div>
        </div>
      </div>
      <div class="goldPriority">
        <div class="priorityTitle">
          <span>免费送</span> 黄金会员专属权益
        </div>
        <div class="priorityContent clearfix">
          <div class="delay fl">
            <div class="icon"></div>
            <div class="desc">延误宝2个/月</div>
          </div>
          <div class="speed fl">
            <div class="icon"></div>
            <div class="desc">提速宝12个/月</div>
          </div>
          <div class="hotel fl">
            <div class="icon"></div>
            <div class="desc">酒店专享9.4折</div>
          </div>
          <div class="birthday fl">
            <div class="icon"></div>
            <div class="desc">29元生日礼物</div>
          </div>
          <div class="grab fl">
            <div class="icon"></div>
            <div class="desc">抢票1.5倍加速</div>
          </div>
        </div>
      </div>
    </div>
    <div class="confirmDredge fx-row" @click="gotoConfirm(0)">
      <div class="desc">限时特惠,立刻开通</div>
      <div class="price">￥49/年</div>
    </div>
    <share :isShow="isShowShare" @show="showShare" @close="closeShare"></share>
  </div>
</template>
<script>
import { mapMutations, mapState } from "vuex";
import nativeAPI from "@/utils/native-api";
import ga from "@/utils/tracker.js";
import share from "./components/share";
import setNavigationBarColor from "./mixin/setNavigationBarColor.js";

export default {
  data() {
    return {
      isShowShare: false,
      navigationBarColor: "255,255,255,1"
    };
  },
  mixins: [setNavigationBarColor],
  created() {
    this.judgeNative();
  },
  mounted() {
    this.$updateTitle("黄金会员礼包");
    if (!this.isNative) {
      this.h5Share();
    }
  },
  computed: {
    ...mapState("vipCard/goldSale", ["isNative"])
  },
  components: {
    share
  },
  methods: {
    ...mapMutations("vipCard/goldSale", ["changeGiftType", "changeIsNative"]),
    showShare() {
      this.isShowShare = true;
    },
    closeShare() {
      this.isShowShare = false;
    },
    h5Share() {
      var shareHtml, shareScript;

      shareHtml = document.createElement("div");
      shareHtml.setAttribute("style", "display:none;");

      var title = document.createElement("div");
      title.setAttribute("id", "fenxiang_title");
      var title_text = document.createTextNode(
        "高铁管家黄金会员超值大礼包，限时特惠"
      );
      title.appendChild(title_text);
      shareHtml.appendChild(title);

      var img = document.createElement("div");
      img.setAttribute("id", "fenxiang_img");
      var img_content = document.createTextNode(
        "https://cdn.133.cn/gtgj/web/goldSale/sharepng@2x.png"
      );
      img.appendChild(img_content);
      shareHtml.appendChild(img);

      var desc = document.createElement("id", "fenxiang_desc");
      desc.setAttribute("id", "fenxiang_desc");
      var desc_content = document.createTextNode("购会员礼包，享会员专属权益");
      desc.appendChild(desc_content);
      shareHtml.appendChild(desc);

      shareHtml.appendChild(desc);

      var link = document.createElement("div");
      link.setAttribute("id", "fenxiang_link");
      var link_content = document.createTextNode(
        "https://h5.133.cn/gtgjwap/h5/vipCard/goldSale"
      );
      link.appendChild(link_content);
      shareHtml.appendChild(link);

      document.body.appendChild(shareHtml);

      // shareScript
      //   = '<script ' +
      //   'data-main="//jp.rsscc.com/promotion/scripts/wechattools/main" ' +
      //   'src="//jp.rsscc.com/promotion/scripts/wechattools/require.js">' +
      //   '&lt;/script>';

      shareScript = document.createElement("script");

      shareScript.setAttribute(
        "data-main",
        "//jp.rsscc.com/promotion/scripts/wechattools/main"
      );

      shareScript.src =
        "//jp.rsscc.com/promotion/scripts/wechattools/require.js";

      document.body.appendChild(shareScript);
    },
    judgeNative() {
      // console.log('panduan');
      nativeAPI
        .invoke("getDeviceInfo")
        .then(res => {
          if (res) {
            this.changeIsNative(true);
          }
        })
        .catch(err => {
          this.changeIsNative(false);
        });
    },
    gotoConfirm(type) {
      ga.track("goldSale", "clickOpenVIP", "browser");
      this.changeGiftType(type);
      this.$router.push({
        path: `/vipCard/goldSaleOpen`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/_vars.scss";
@import "./style/common.scss";

.goldSale {
  min-height: 100%;
  background-color: #000;
  .head {
    position: relative;
    overflow: hidden;
    height: 179 * $px;
  }
  .light {
    width: 208 * $px;
    height: 148 * $px;
    position: absolute;
    z-index: 0;
    right: 0;
    top: 0;
    @include bg("light@3x.png");
  }
  .header {
    width: 375 * $px;
    padding: 27 * $px 0 24 * $px 0;
    position: absolute;
    top: 0;
    left: 0;
    .cost {
      margin: 0 auto;
      width: 221 * $px;
      height: 29 * $px;
      @include bg("cost@3x.png");
      margin-bottom: 10 * $px;
    }
    .goldBox {
      margin: 0 auto;
      margin-bottom: 10 * $px;
      width: 217 * $px;
      height: 28 * $px;
      line-height: 28 * $px;
      background-image: linear-gradient(-180deg, #d7a15d 0%, #cc9d64 100%);
      box-shadow: inset 0 1px 1px 0 rgba(255, 253, 251, 0.47);
      border-radius: 14px;
      font-size: 16 * $px;
      color: #593600;
      letter-spacing: 1px;
      text-align: center;
      font-family: PingFangSC-Medium;
      span {
        color: #ffebc2;
      }
    }
    .differentTrip {
      margin: 0 auto;
      width: 284 * $px;
      height: 51 * $px;
      @include bg("differentTrip@3x.png");
    }
  }
  .body {
    // margin-top: 172*$px;
    width: 375 * $px;
    height: 506 * $px;
    overflow: hidden;
    padding-bottom: 54 * $px;
    @include bg("body1@3x.png");
    .title {
      margin-top: 16 * $px;
      margin-left: 29 * $px;
      margin-bottom: 16 * $px;
      font-family: PingFangSC-Semibold;
      font-size: 16px;
      color: #593600;
      letter-spacing: 0;
    }
    .passengerGift,
    .speedGift {
      margin-left: 29 * $px;
      margin-bottom: 10 * $px;
      @include bg("unselected1@3x.png");
      width: 317 * $px;
      height: 107 * $px;
      position: relative;
      .left {
        overflow: hidden;
        position: absolute;
        top: 0;
        left: 12 * $px;
        .passengerGiftTitle,
        .speedGiftTitle {
          margin-top: 16 * $px;
          font-family: PingFangSC-Medium;
          font-size: 14 * $px;
          color: #593600;
          letter-spacing: 0;
          line-height: 13 * $px;
          margin-bottom: 10 * $px;
        }
        .desc {
          font-family: PingFangSC-Regular;
          font-size: 12 * $px;
          color: #ba792f;
          letter-spacing: 0;
          line-height: 12 * $px;
          margin-bottom: 8 * $px;
          position: relative;
          // padding-left: 12*$px;
          padding-left: 12 * $px;
          &::before {
            position: absolute;
            top: 3 * $px;
            left: 1 * $px;
            display: block;
            content: "";
            height: 5 * $px;
            width: 5 * $px;
            transform: rotate(-45deg);
            background: #ba792f;
            border-radius: 1 * $px;
          }
        }
        .subDesc {
          font-family: PingFangSC-Regular;
          font-size: 10 * $px;
          color: #dab589;
          letter-spacing: 0;
        }
      }
      .right {
        position: absolute;
        top: 25 * $px;
        right: 14 * $px;
        width: 54 * $px;
        height: 54 * $px;
        background: #f7e1b2;
        border-radius: 50%;
        box-sizing: border-box;
        .buyNow {
          font-family: PingFangSC-Medium;
          font-size: 13 * $px;
          color: #ba792f;
          letter-spacing: 0;
          text-align: center;
          line-height: 15 * $px;
        }
      }
    }
    .speedGift {
      @include bg("unselectedTwo@3x.png");
    }
    .goldPriority {
      .priorityTitle {
        font-family: PingFangSC-Medium;
        margin-top: 53 * $px;
        margin-bottom: 20 * $px;
        font-size: 15 * $px;
        line-height: 21 * $px;
        color: #fcebc7;
        text-align: center;
        position: relative;
        span {
          color: #fff;
        }
        &::before {
          content: "";
          display: block;
          position: absolute;
          left: 15 * $px;
          width: 76 * $px;
          height: 9 * $px;
          margin-top: 6 * $px;
          @include bg("left@3x.png");
        }
        &::after {
          content: "";
          display: block;
          position: absolute;
          top: 0;
          right: 15 * $px;
          width: 76 * $px;
          height: 9 * $px;
          margin-top: 6 * $px;
          @include bg("rigtht@3x.png");
        }
      }
      .priorityContent {
        padding: 0 57 * $px 0 51 * $px;
        .delay,
        .speed,
        .hotel,
        .birthday,
        .grab {
          margin: 8 * $px 25 * $px 8 * $px 0;
          .icon {
            margin: 0 auto;
            width: 30 * $px;
            height: 30 * $px;
            @include bg("icon1@3x.png");
          }
          .desc {
            font-family: PingFangSC-Regular;
            font-size: 11 * $px;
            color: rgba(255, 255, 255, 0.8);
            letter-spacing: 0;
            text-align: center;
          }
        }
        .speed {
          .icon {
            @include bg("speed@3x.png");
          }
        }
        .hotel {
          margin-right: 0;
          .icon {
            @include bg("hotel@3x.png");
          }
        }
        .birthday {
          .icon {
            @include bg("birthday.png");
          }
        }
        .grab {
          .icon {
            @include bg("grab@3x.png");
          }
        }
      }
    }
  }
  .confirmDredge {
    position: fixed;
    bottom: 0;
    height: 54 * $px;
    line-height: 54 * $px;
    background-color: #fdfbf9;
    padding-left: 16 * $px;
    box-sizing: border-box;
    .desc {
      width: 245 * $px;
      font-family: PingFangSC-Regular;
      font-size: 18 * $px;
      color: #593600;
    }
    .price {
      font-family: PingFangSC-Medium;
      width: 130 * $px;
      text-align: center;
      font-size: 18 * $px;
      color: #ffebc2;
      background-image: linear-gradient(45deg, #4b2900 0%, #593010 100%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/projects/vipCard/pages/goldSale/index.vue